<template>
  <section class="bx-search__header bx-typo--search-header bx-filters bx-filters--static">
    <div>
      <a :href="shortLink.url"
         class="bx-js-active bx-typo--bold"
         :aria-label="`Zum heutigen Programm ${shortLink.text}`">
        {{ shortLink.text }}
      </a>
    </div>
    <h2 v-if="headline">
      {{ headline }}
    </h2>
  </section>
</template>

<script>
export default {
  props: {
    headline: {
      type: String,
      default: null
    },
    shortLink: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
